export default function Hero() {
  const handleScroll = (anchor: string) => {
    const el = document.querySelector(anchor);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20art%20composition%20with%20rich%20warm%20amber%20and%20deep%20crimson%20tones%2C%20film%20reel%20and%20spotlight%20elements%2C%20soft%20bokeh%20lights%2C%20elegant%20dark%20atmospheric%20background%20with%20golden%20highlights%2C%20luxurious%20cinema%20texture%2C%20artistic%20grain%2C%20refined%20theatrical%20mood&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="555电影网 - 免费高清电影在线观看平台主视觉"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-7xl mx-auto">
          {/* Left text */}
          <div className="flex-1 text-center lg:text-left w-full">
            {/* Topic tags */}
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-4 flex-wrap">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-500/20 text-accent-700 text-xs font-medium whitespace-nowrap">
                <i className="ri-fire-line mr-1"></i>今日更新
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-primary-500/15 text-primary-600 text-xs font-medium whitespace-nowrap">
                <i className="ri-movie-2-line mr-1"></i>高清专区
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-secondary-500/15 text-secondary-600 text-xs font-medium whitespace-nowrap">
                <i className="ri-star-line mr-1"></i>编辑精选
              </span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight mb-3">
              555电影网 · 免费高清在线观影平台
            </h1>

            {/* Slogan */}
            <p className="text-lg md:text-xl text-white/80 font-heading mb-5">
              海量全集电影 · 不缓冲秒播放 · 随时随地畅享影院级体验
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              555电影网汇聚全球最新院线大片与经典电影资源，覆盖动作、悬疑、喜剧、科幻等全品类内容。
              每日更新片库，支持超清1080P画质在线点播，无需注册、无需下载、无需付费，
              打开网页即可享受流畅的电影观影体验。无论您是资深影迷还是休闲观众，
              都能在555电影网找到心仪的影片，发现更多光影世界的精彩。
            </p>

            {/* Stats */}
            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-10 mb-7 flex-wrap">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">100,000+</div>
                <div className="text-xs text-white/60 mt-1">影片资源</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5000万+</div>
                <div className="text-xs text-white/60 mt-1">月活用户</div>
              </div>
              <div className="w-px h-10 bg-white/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">24h</div>
                <div className="text-xs text-white/60 mt-1">持续更新</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#cards');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  handleScroll('#features');
                }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white font-medium text-sm rounded-md border border-white/30 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          {/* Right visual */}
          <div className="flex-1 hidden lg:flex items-center justify-center w-full">
            <div className="relative w-full max-w-[500px] aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20projector%20abstract%20art%20with%20warm%20golden%20light%20beam%2C%20floating%20film%20frames%2C%20soft%20bokeh%20particles%2C%20rich%20amber%20and%20crimson%20gradients%2C%20elegant%20dark%20background%2C%20luxurious%20theater%20mood%2C%20artistic%20texture%2C%20refined%20cinema%20aesthetic&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="555电影网影院级观影体验主视觉"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}